import { styled } from "@mui/material";
import { Colors } from "../../../config/palette";
import Skeleton from "@mui/material/Skeleton";

export const SkeletonWrapper = styled(Skeleton)(() => ({
  background: Colors.dark,
}));
